import Table, { TableBody } from '@ingka/table';
import Text from '@ingka/text';
import { useTranslation } from 'react-i18next';
import { DownloadSwipeQuestions } from '@lotta/self-service/lottery-fe/ui-common';
import Accordion, { AccordionItem } from '@ingka/accordion';
import styles from '../LotteryConfigOverview.module.scss';
import type { LotteryConfigData } from '../types';

export const SwipeInformationTable: React.FC<{
  values: LotteryConfigData;
}> = ({ values: { translation, lottery } }) => {
  const { t } = useTranslation();
  // eslint-disable-next-line i18next/no-literal-string
  const questionsFileName = `${t('swipe-questions').toLowerCase()}.xlsx`;

  const tableRow = (key: string, label: string, value: string | number | undefined) => (
    <tr key={key}>
      <td className={styles['heading']}>
        <Text>{t(label)}</Text>
      </td>
      <td>
        <Text>{value}</Text>
      </td>
    </tr>
  );
  const config = lottery.swipe?.config;
  const mode = config?.modeData.mode;

  return (
    <>
      <Table>
        <TableBody className={styles['tbody']}>
          {config?.modeData.mode && tableRow('mode', 'swipe-info-mode', config?.modeData.mode)}
          {config?.timePerQuestion &&
            tableRow('timePerQuestion', 'swipe-time-per-question', config?.timePerQuestion)}
          {mode === 'NORMAL' &&
            config?.modeData.numberOfCorrectAnswers &&
            tableRow(
              'numberOfCorrectAnswers',
              'swipe-info-number-of-correct-answers',
              config?.modeData.numberOfCorrectAnswers
            )}
          {mode === 'NORMAL' &&
            config?.modeData.maxNumberOfLives &&
            tableRow(
              'maxNumberOfLives',
              'swipe-info-max-number-of-lives',
              config?.modeData.maxNumberOfLives
            )}
          {mode === 'PEACEFUL' &&
            config?.modeData.amountOfQuestions &&
            tableRow(
              'amountOfQuestions',
              'swipe-info-amount-of-questions',
              config.modeData.amountOfQuestions
            )}
        </TableBody>
      </Table>
      <div className={styles['sub-accordion']}>
        <Accordion>
          {Object.entries(translation).map(([language, data]) => {
            const { swipe } = data;
            const capitalizedLanguage = language.toUpperCase();
            if (!swipe) {
              return null;
            }
            return (
              <AccordionItem
                title={`${t('form-accordion-swipe-translations-language', {
                  capitalizedLanguage,
                })}`}
                id={`swipe-translations-${capitalizedLanguage}`}
                key={`swipe-translations-${capitalizedLanguage}`}
                open={Object.entries(translation).length === 1}
              >
                <Table>
                  <TableBody className={styles['tbody']}>
                    {tableRow('title', 'form-sign-up-swipe-config-title-label', swipe.title)}
                    {tableRow('body', 'form-sign-up-swipe-config-body-label', swipe.body)}
                    {tableRow(
                      'startPageImage',
                      'form-sign-up-swipe-config-start-image-label',
                      swipe.links?.startPageImage
                    )}
                    {tableRow(
                      'winnerPageImage',
                      'form-sign-up-swipe-config-winner-image-label',
                      swipe.links?.winnerPageImage
                    )}
                    {tableRow(
                      'loserPageImage',
                      'form-sign-up-swipe-config-loser-image-label',
                      swipe.links?.loserPageImage
                    )}
                    <tr key="questions">
                      <td className={styles['heading']}>
                        <Text>{t('swipe-overview-swipe-questions')}</Text>
                      </td>
                      <td>
                        <DownloadSwipeQuestions
                          questions={swipe.questions}
                          label={questionsFileName}
                          fileName={questionsFileName}
                        />
                      </td>
                    </tr>
                  </TableBody>
                </Table>
              </AccordionItem>
            );
          })}
        </Accordion>
      </div>
    </>
  );
};
